<template>
  <div class="xbig ybig">
    <vs-prompt :vs-title="'Email Gönder #' + currentItem.saleOrderId" vs-cancel-text="Vazgeç" vs-button-cancel="border" @vs-close="cancel" @vs-cancel="cancel" :vs-active.sync="visible" :vs-is-valid="validateForm">
      <vcl-table secondary="#ff9f43" v-if="loading"></vcl-table>
      <div class="ml-5 mr-5" v-if="!loading">
        <div class="vx-row">
          <div class="vx-col w-1/6">
            <span>Müşteri:</span>
          </div>
          <div class="vx-col w-2/3">
            <span>{{ currentItem.customer }}</span>
          </div>
        </div>
        <div v-if="phone.visible" class="vx-row my-2">
          <div class="vx-col w-1/6 flex items-center">
            <span>Telefonu:</span>
          </div>
          <div class="vx-col w-2/3 flex items-center">
            <a :href="phone.link" class="flex items-center mr-5">{{ phone.text }}</a>
            <a v-if="whatsapp.visible" :href="whatsapp.link" class="flex items-center" target="_blank">
              <svg :style="whatsappStyle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
                <path :d="whatsappIcon" fill-rule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
        <hr />
        <div class="vx-row flex items-center mx-10 my-3">
          <div class="vx-col w-1/2">
            <b>Ürün</b>
          </div>
          <div class="vx-col w-1/4">
            <b>Adet</b>
          </div>
        </div>
        <div style="height: 200px; overflow-y: scroll">
          <div class="vx-row flex items-center mx-10 my-2" v-for="(tr, i) in currentItem.products" :key="tr.orderLineId">
            <div class="vx-col w-1/2">● {{ tr.productName }}</div>
            <div style="text-align:right;" class="vx-col w-1/12">{{ tr.productAmount }}</div>
            <hr v-if="i != currentItem.products.length - 1" class="vx-col w-3/5" :style="hrStyle" />
          </div>
        </div>
        <hr />
        <div class="vx-row flex items-center my-3">
          <div class="vx-col w-1/6 flex items-center">
            <label for="email">E-mail Adresi:</label>
          </div>
          <div class="vx-col w-2/3">
            <input class="w-2/3 p-1" type="email" id="email" name="email" placeholder="E-Mail adresi giriniz" onfocus="this.select();" v-model="email" />
          </div>
        </div>
        <vs-textarea class="w-full" v-model="currentItem.saleOrderNote" placeholder="Mesajınızı yazın" v-validate="'required'" name="txtMessage" :color="validateForm ? 'success' : 'danger'" onfocus="this.select();" />
      </div>
      <p v-if="counter > 0" class="bg-warning p-2">Teklif dosyası oluşturulurken lütfen bekleyin.&nbsp;{{ second }} sonra indirme işleminiz başlayacak.</p>
      <!-- <a :href="link" style="display:none;" id="lnkDownloadPdf" target="_blank">Download Pdf</a>
      <a :href="link2" style="display:none;" target="_blank">Download Pdf2</a> -->
      <vs-button id="btnKaydet" type="filled" @click="submit">Kaydet</vs-button>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import { VclTable } from "vue-content-loading";
export default {
  components: {
    VclTable,
  },
  props: {
    currentItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      link2: null,
      visible: true,
      loading: true,
      counter: 0,
      second: 3,
      link: "",
      email: "",
      hrStyle: {
        border: "#ddd",
        color: "#ddd",
        background: "#ddd",
        height: "1px",
      },
      whatsappStyle: {
        width: "25px",
        height: "25px",
        background: "#4dc247",
        fill: "white",
        borderRadius: "50%",
        padding: "2px",
      },
      whatsappIcon:
        "M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z",
      whatsapp: {
        link: "",
        visible: false,
        value: Number,
        text: "",
      },
      phone: {
        link: "",
        visible: false,
        value: Number,
        text: "",
      },
    };
  },
  created() {
    this.currentItem = repository.convertToJSON(this.currentItem, "customerPhone");
    this.getData();
    setTimeout(() => {
      document.querySelector("footer").firstElementChild.remove();
      document.querySelector("footer").insertBefore(document.getElementById("btnKaydet"), document.querySelector("footer").firstElementChild);
    }, 50);
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    getData: async function() {
      let c = this.currentItem;
      this.fillWhatsapp(c);
      this.fillPhone(c);
      let x = await repository.getById("customer/getById", c.customerId);
      if (x) {
        if (x.list && x.list.length == 1 && x.isSuccessful) {
          this.email = x.list[0].email;
        } else {
          if (x.hasExceptionError && x.exceptionMessage) {
            alert(x.exceptionMessage);
          }
        }
      }
      this.loading = false;
    },
    fillPhone() {
      if (this.whatsapp.visible) {
        this.phone.text = this.whatsapp.text;
        this.phone.link = "tel:" + this.whatsapp.value;
        this.phone.visible = true;
        this.phone.value = this.whatsapp.value;
      }
    },
    fillWhatsapp(c) {
      if (c.customerPhone && Array.isArray(c.customerPhone) && c.customerPhone.length > 0)
        for (let i = 0; i < c.customerPhone.length; i++) {
          let cp = c.customerPhone[i];
          if (cp.isWhatsapp) {
            let full = "";
            if (cp.value)
              if (cp.prefix && cp.prefix > 0) {
                full = (cp.prefix.toString() + cp.value.toString()).replace(/[\s\n\r]+/g, "");
              } else {
                full = cp.value;
              }
            if (full && full.length > 0) {
              let x = parseInt(full);
              this.whatsapp = {
                visible: true,
                text: "+" + full,
                link: "https://wa.me/" + full,
                value: isNaN(x) ? 0 : x,
              };
            }
            break;
          }
        }
    },
    submit: async function() {
      let r = await repository.postEntity("Customer/SendEmailForOrder", {
        orderId: this.currentItem.saleOrderId,
        email: this.email,
        message: this.currentItem.saleOrderNote,
        orderType: 2,
      });

      await this.downloadOfferFile(r.entity);
    },

    downloadOfferFile: async function(r) {

      console.log(r);
      await repository
        .DownloadStream("Customer/DownloadSaleOfferFile" + "/" + r.key + "/" + r.name+".pdf")
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = r.key;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); //afterwards we remove the element again
        });
    },
    cancel() {
      this.visible = true;
      this.$emit("updateCompleted", 0);
    },
  },
};
</script>
